// PREPREND CART

/** @return {object} - get data prepare for cart call */
const getPreprendCartData = state => {
  return state.preprendCartData;
};

/** @return {object} - get data prepare for cart call */
const getPreprendCartDeliveryData = state => {
  let preprendCartDeliveryData = {
    mcp_intervention_zipcode: state.preprendCartData.mcp_intervention_zipcode,
    mcp_intervention_slot: state.preprendCartData.mcp_intervention_slot,
    mcp_intervention_fake_slot: state.preprendCartData.mcp_intervention_fake_slot,
    mcp_intervention_date: state.preprendCartData.mcp_intervention_date,
    mcp_additional_sku: state.preprendCartData.mcp_additional_sku,
    mcp_intervention_product: state.preprendCartData.mcp_intervention_product,
    mcp_agency: state.preprendCartData.mcp_agency,
  };
  return preprendCartDeliveryData;
};

/** @return {object} - get data prepare for cart call */
const getPreprendCartNeedCartCleaning = state => {
  return state.preprendCartData.need_cart_cleaning;
};

/** @return {object} - get data prepare for cart call */
const getPreprendCartCurrentSelectedDelivery = state => {
  return state.currentSelectedDelivery;
};

/** @return {object} - get data prepare for cart call */
const getPreprendCartCurrentSelectedService = state => {
  let service = state.currentSelectedDelivery;
  if (service === 'delivery_only') {
    service = "retail";
  }
  return service;
};

/** @return {object} - get data prepare for cart call */
const getPreprendCartStandardDeliveryInCart = state => {
  return state.preprendCartData.standard_delivery_in_cart;
};

/** @return {object} - get data prepare for cart call */
const getPreprendCartInstallationProductInCart = state => {
  return state.preprendCartData.installation_product_in_cart;
};

/** @return {object} - get data prepare for cart call */
const getPreprendCartDeliveryOnly = state => {
  return state.preprendCartData.delivery_only;
};

/** @return {object} - get data prepare for cart call */
const getPreprendCartIsExclusive = state => {
  return state.preprendCartData.is_exclusive;
};

/** @return {object} - get data prepare for cart call */
const getPreprendCartQuantity = state => {
  return state.preprendCartData.qty;
};

/** @return {object} - get data prepare for cart call */
const getTaxProfile = state => {
  return state.tax_profile;
};
/** @return {object} - get additionalInfo */
const getPreprendCartAdditionalInfo = state => {
  return state.additionalInfo;
};

const getPreprendCartInterventionProduct = state => {
    return state.preprendCartData.mcp_intervention_product;
};

/** @return {object} - get data prepare for cart call */
const getPreprendCartRelatedProduct = state => {
    return state.preprendCartData.related_product;
};

const getPreprendCartIsRenting = state => {
    return state.preprendCartData.is_renting;
};
const getPreprendCartIsFinancing = state => {
    return state.preprendCartData.is_financing;
};

const getPreprendCartRentingNbMonths = state => {
    return state.preprendCartData.nb_months;
};
const getPreprendCartFinancingNbMonths = state => {
    return state.preprendCartData.nb_months_financing;
};

export default {
  getPreprendCartData,
  getTaxProfile,
  getPreprendCartNeedCartCleaning,
  getPreprendCartStandardDeliveryInCart,
  getPreprendCartInstallationProductInCart,
  getPreprendCartDeliveryOnly,
  getPreprendCartIsExclusive,
  getPreprendCartQuantity,
  getPreprendCartAdditionalInfo,
  getPreprendCartDeliveryData,
  getPreprendCartCurrentSelectedDelivery,
  getPreprendCartCurrentSelectedService,
  getPreprendCartInterventionProduct,
  getPreprendCartRelatedProduct,
  getPreprendCartIsRenting,
  getPreprendCartIsFinancing,
  getPreprendCartRentingNbMonths,
  getPreprendCartFinancingNbMonths,
};
